function klevu_afterLandingResultsLoaded(results) {
  // REODER Size facet
  var sizeFacetLabelArr = document.querySelectorAll('#kuFilterNames-size ul li a');
  var sizeOrderedArray = ["1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "13.5", "XS", "M", "060M"];

  function defineSizeOrder(sizeFacetLabel_item) {
    for (var k = 0; k < sizeOrderedArray.length; k++) { // loop through all size variants
      var sizeOrdered_item = sizeOrderedArray[k].toLowerCase();

      if (sizeFacetLabel_item.getAttribute("title").toLowerCase() === sizeOrdered_item) {
        sizeFacetLabel_item.parentElement.style.order = (k + '');
        break;
      } else {
        sizeFacetLabel_item.parentElement.style.order = '200';
      }
    }
  }

  // loop thrugh all size DOM-elements
  for (var i = 0; i < sizeFacetLabelArr.length; i++) {
    var sizeFacetLabel = sizeFacetLabelArr[i];
    defineSizeOrder(sizeFacetLabel);
  }
}

$(window).on("load", function () {
  var sortEl = document.getElementById('kuSortby');
  var myInterval = setInterval(checkingLoadingKlevu, 100);
  var klevuElement = '.klevuImgWrap a';

  function checkingLoadingKlevu() {
    if ($(document.querySelectorAll(klevuElement)).length > 0) {
      stopCheckingLoadingKlevu();

      if (window.location.pathname.includes('collections/new-arrivals')) {
        sortEl.value = 'NEW_ARRIVAL_DESC';
      } else {
        sortEl.value = 'NAME_ASC';
      }

      sortEl.dispatchEvent(new Event('change'));
      console.log(1);
    }
  }

  function stopCheckingLoadingKlevu() {
    clearInterval(myInterval);
  }
});